import { wrapActions, wrapMultiSelector, wrapSelector } from 'store/utils';

import * as actions from './actions';
import { getErrors, getErrorsByType, getIsExistError } from './selectors';

export const useErrorsActions = wrapActions({ ...actions });

export const useErrors = wrapMultiSelector(getErrorsByType, getErrors);
export const useIsExistError = wrapSelector(getIsExistError);
